import { render, staticRenderFns } from "./five.html?vue&type=template&id=4453cfd2&external"
import script from "./five.vue?vue&type=script&lang=js"
export * from "./five.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports